// Firebase 설정 (Vite 환경용)
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Emulator 모드 체크
const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

// 환경변수 확인 (개발 환경 + 디버그 모드)
if (import.meta.env.DEV || import.meta.env.VITE_APP_DEBUG === 'true') {
  console.log('🔧 Firebase Config Check:');
  console.log('- API Key:', firebaseConfig.apiKey ? '✅ Set' : '❌ Missing');
  console.log('- Auth Domain:', firebaseConfig.authDomain ? '✅ Set' : '❌ Missing');
  console.log('- Project ID:', firebaseConfig.projectId ? '✅ Set' : '❌ Missing');
  console.log('- Storage Bucket:', firebaseConfig.storageBucket ? '✅ Set' : '❌ Missing');
  console.log('- Messaging Sender ID:', firebaseConfig.messagingSenderId ? '✅ Set' : '❌ Missing');
  console.log('- App ID:', firebaseConfig.appId ? '✅ Set' : '❌ Missing');
  console.log('- Environment:', import.meta.env.MODE);
  console.log('- Debug Mode:', import.meta.env.VITE_APP_DEBUG);
  console.log('- Use Emulator:', useEmulator);
}

// Firebase 초기화
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Emulator 연결 (개발 환경에서만)
if (useEmulator && import.meta.env.DEV) {
  try {
    connectAuthEmulator(auth, 'http://localhost:9199');
    connectFirestoreEmulator(db, 'localhost', 8181);
    console.log('🧪 Firebase Emulator connected!');
    console.log('- Auth Emulator: http://localhost:9199');
    console.log('- Firestore Emulator: http://localhost:8181');
    console.log('- Emulator UI: http://localhost:4401');
  } catch (error) {
    console.warn('⚠️ Emulator connection failed:', error.message);
  }
}

console.log('🔥 Firebase initialized successfully!');
console.log('📋 Project ID:', firebaseConfig.projectId);
console.log('🎯 Mode:', useEmulator ? 'Emulator' : 'Production');

export { auth, db };
export default app;